import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const BuyerProtection = () => {
  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', backgroundColor: '#fff', paddingTop: '120px', paddingBottom: '60px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '20px', color: '#dc2626', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
          
          <div style={{ backgroundColor: '#000', color: '#fff', padding: '30px', marginBottom: '30px', borderRadius: '8px' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>Buyer Protection & Dispute Resolution Policy</h1>
            <p style={{ opacity: 0.9 }}>Operated by MAXRAD SOFTWARE INDIA PVT LTD (Brand name ARTCARDO under the division DULCIA.ART)</p>
            <p style={{ opacity: 0.7, marginTop: '5px' }}>1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
          </div>

          <div style={{ backgroundColor: '#f9fafb', padding: '30px', borderRadius: '8px', lineHeight: '1.8' }}>
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>1. Introduction</h2>
              <p style={{ color: '#374151' }}>
                This Buyer Protection & Dispute Resolution Policy ensures fair, transparent, and efficient resolution of disputes between Buyers and Sellers.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>2. Eligible Claims</h2>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                <li style={{ marginBottom: '8px' }}>Product not received after dispatch</li>
                <li style={{ marginBottom: '8px' }}>Product received damaged or defective</li>
                <li style={{ marginBottom: '8px' }}>Product significantly different from listing</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>3. Claim Window</h2>
              <p style={{ color: '#374151' }}>
                All claims must be raised within 5 days of delivery.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>4. Contact Information</h2>
              <p style={{ color: '#374151' }}><strong>MAXRAD SOFTWARE INDIA PVT LTD</strong></p>
              <p style={{ color: '#374151' }}>(Brand name ARTCARDO under the division DULCIA.ART)</p>
              <p style={{ color: '#374151' }}>Email: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a></p>
              <p style={{ color: '#374151' }}>Phone: <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a></p>
              <p style={{ color: '#374151' }}>Address: 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BuyerProtection;
